import { useQuery } from '@tanstack/react-query';
import { api } from 'constants/api';

import { ApiResponse } from 'types/utils/api-response';

export type BusinessStatsType = {
  credit_balance: number;
  current_audience: number;
  confirmed_deliveries: number;
  id: number;
  is_active: number;
  messages_sent: number;
  name: number;
  unique_recipients: number;
  total_revenue: number;
  credit_warning: boolean;
};

export type BusinessStatsResponseType = BusinessStatsType;

export const useGetBusinessStats = (
  businessId?: string,
  channel?: string
) => {
  return useQuery({
    queryKey: ['business', { id: businessId, channel }],
    enabled: Boolean(businessId),
    queryFn: async (): Promise<BusinessStatsResponseType> => {
      const params = channel ? `?channel=${channel}` : '';
      const { data } = await api.get<ApiResponse<BusinessStatsResponseType>>(
        `/business/aggregate-analytics/${businessId}${params}`
      );

      return data.data;
    },
  });
};
